export default __webpack_public_path__ + "static/media/mobile1.9e693b1c.svg";